import { useGetEnabledFeatureFlags } from 'core/contexts/feature-flags/hooks/use-get-enabled-feature-flags.hook';
import { useTranslation } from 'core/i18n/i18n';
import { useGetSettingsDevicesMenu } from '../pods/settings-devices/use-settings-devices-menu.hook';
import { settingsModulePaths } from 'core/routes/routes';
import { SettingsSideBarSection } from '../components/side-menu-list';

export const useSettingsAdmSideBarMenu = (): SettingsSideBarSection[] => {
    const { settingsDevicesMenuOptions } = useGetSettingsDevicesMenu();
    const enabledFeatureFlags = useGetEnabledFeatureFlags();
    const { t } = useTranslation();
    return [
        ...(enabledFeatureFlags?.includes('deviceManagementEnabled')
            ? [
                  {
                      title: t('settings.menu.devicesManagement'),
                      items: [
                          {
                              title: t('settings.menu.devicesManagement.eapSettings'),
                              url: settingsModulePaths.eapSettings,
                          },
                          {
                              title: t('settings.menu.devicesManagement.predefinedComments'),
                              url: settingsModulePaths.predefinedComments,
                          },
                          ...settingsDevicesMenuOptions,
                      ],
                  },
              ]
            : []),
    ];
};
